module.exports = __webpack_public_path__ + "static/33rd-eda9e5c419606f8b8d19de27d01a740c.png";